/**
 * 会員限定商品の購入制御用JavaScript
 */
document.addEventListener('DOMContentLoaded', function() {
  // 会員限定商品の非会員ユーザー向けダミーボタン制御
  const membershipDummyButton = document.querySelector('[data-button-type="membership-dummy-button"]');
  if (membershipDummyButton) {
    const errorMessage = document.getElementById('membership-error-message');
    
    membershipDummyButton.addEventListener('click', function(e) {
      e.preventDefault();
      
      // エラーメッセージを表示
      membershipDummyButton.classList.add('is-disabled');
      if (errorMessage) {
        errorMessage.style.display = 'block';
      }
    });
  }
});
